<!-- Wrapper for an actual specific field, ensures a common look. -->

<template>
  <v-layout
    :style="{
      opacity: disabled ? 0.5 : 1.0,
      'pointer-events': disabled ? 'none' : 'initial',
    }"
  >
    <strong
      v-if="index"
      class="branding-field-numbering subheading mr-3"
      style="position: relative; top: 28px"
    >
      {{ index }}
    </strong>
    <v-layout column>
      <v-layout
        v-if="!noLabel"
        class="body-2 grey--text text--darken-3 mb-2"
        align-center
      >
        {{ (label || '&nbsp;').toUpperCase() }} <slot name="labelsuffix" />
      </v-layout>
      <v-layout
        class="d-flex branding-field-box"
        :style="{
          'max-width': maxWidth,
          'min-width': minWidth,
          'max-height': maxHeight,
          'min-height': minHeight,
        }"
        :class="{border: border}"
      >
        <slot name="field" />
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    index: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    minWidth: {
      type: String,
      default: '200px',
    },
    minHeight: {
      type: String,
      default: '200px',
    },
    maxWidth: {
      type: String,
      default: null,
    },
    maxHeight: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.branding-field-box {
  border: 3px solid transparent; /* To keep the box-sizing. */
}
.branding-field-box.border {
  border: 3px dashed rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.branding-field-numbering {
  width: 28px;
  height: 28px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.35);
  border: 2px solid rgba(0, 0, 0, 0.35);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandingField.vue